import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#05030A" }}>
      <div className="noise-overlay" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="glass-card rounded-2xl p-10 sm:p-12 max-w-md w-full mx-6 text-center relative z-10"
      >
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-yellow-500/10 border border-yellow-500/20 flex items-center justify-center">
          <XCircle className="w-8 h-8 text-yellow-400" />
        </div>
        <h2 className="font-['Outfit'] text-2xl font-bold text-white mb-2" data-testid="payment-cancel-title">
          Payment cancelled
        </h2>
        <p className="text-sm text-[#A19BB0] mb-8">
          No worries — you weren't charged. You can start your trial anytime.
        </p>
        <Link
          to="/pricing"
          data-testid="back-to-pricing-button"
          className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-sm text-white bg-white/5 border border-white/10 hover:bg-white/10 transition-colors duration-200"
        >
          Back to pricing
        </Link>
      </motion.div>
    </div>
  );
}
